import React, { useCallback, useRef } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useEventTrackingIdentify from 'EventTracking/useEventTrackingIdentify';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import segmentEvents from 'EventTracking/consts/segmentEvents';
import useHomeContext from 'Context/HomeContext';
import { useBuildCommonFQEventProperties } from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { InfluencerLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/InfluencerLayout';

const InfluencerContactInformation = () => {
  const {
    onSubmit, handleChange, resource,
  } = useMetaLayoutContext();

  const { homeResource } = useHomeContext();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();

  const contactFormRef = useRef(null);

  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const identify = useEventTrackingIdentify();
  const { logEvent } = useEventTrackingLogEvent({
    nodeName: 'facet quiz',
  });

  const currentUrl = new URL(window.location.href);
  const { searchParams: search, href } = currentUrl;

  const handleSubmit = useCallback(() => {
    identify(null, {
      visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
      isInternalUser: resource.attr('emailAddress').includes('@facet'),
      firstName: resource.attr('firstName'),
      lastName: resource.attr('lastName'),
      emailAddress: resource.attr('emailAddress'),
    });
    logEvent(segmentEvents.facetQuizContactInfoSubmitted, {
      visitorSessionUUID: homeResource.attr('visitorSessionUuid'),
    });
    logStandardizedEvent(categories.facetQuiz, eventTypes.contactForm, eventSubTypes.submitForm, {
      eventProperties: {
        ...buildCommonFQEventProperties(resource),
        seenByUser: true,
      },
    });
    onSubmit();
  }, [resource, homeResource]);

  React.useEffect(() => {
    // We need to capture all of the search params that were present on the url since we may
    // have new utm params that we need to override when we create the lead
    handleChange('urlParams', search.toString());
    handleChange('rawUrl', href);
  }, []);

  const handleScrollToContactForm = () => {
    if (contactFormRef.current) {
      return contactFormRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    return window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <InfluencerLayout handleSubmit={handleSubmit} handleLowerCTAClicked={handleScrollToContactForm} />
  );
};

export { InfluencerContactInformation };
